import React from 'react';
import PropTypes from 'prop-types';
import HeaderTitle from 'header/components/title';

const Header = () => (
  <HeaderTitle title="Reset Your Password" />
);

export default Header;
